import { Feature, FeatureCollection } from "geojson";

export const geoJSONBlank: Feature = {
	type: "Feature",
	geometry: { type: "Point", coordinates: [] },
	properties: [],
};

export const geoJSONBlankCollection: FeatureCollection = {
	type: "FeatureCollection",
	features: [],
};

export const geoJSONBlankLine: Feature = {
	type: "Feature",
	geometry: { type: "LineString", coordinates: [] },
	properties: {},
};

export const imageSourceBlank = {
	//Blank pixel
	url: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
	coordinates: [
		[0, 0],
		[0, 1],
		[1, 1],
		[1, 0],
	] satisfies [
		[number, number],
		[number, number],
		[number, number],
		[number, number],
	],
};
